import React from 'react';
import { Content } from 'models/Content';

interface ContentItemProps
{
    content: Content;
    onClick: any;
}

export class ContentItem extends React.Component<ContentItemProps, {}>
{
    public render()
    {
		return (
			<button className='content-program-button' onClick={() => this.props.onClick(this.props.content)}>
				<div>
					<h2>{this.props.content.title}</h2>
					<p>{this.props.content.description}</p>
				</div>
			</button>
		);
    }
}